import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { Passengers } from 'app/shared/models/passenger.model';
@Pipe({
    name: 'prettyPassenger'
})
@Injectable()
export class PrettyPassengerPipe implements PipeTransform {
    transform(input: Passengers): any {
        const adults = input.adults,
            concessions = input.concessions,
            students = input.students,
            children = input.accompaniedChildren,
            seatedInfant = input.seatedInfant,
            nursedInfant = input.nursedInfant,
            passengersPretty = [];

        if (!!adults) {
            if (adults > 1) {
                passengersPretty.push(adults + 'x Adults');
            } else {
                passengersPretty.push(adults + 'x Adult');
            }
        }
        if (!!concessions) {
            if (concessions > 1) {
                passengersPretty.push(concessions + 'x Concessions');
            } else {
                passengersPretty.push(concessions + 'x Concession');
            }
        }
        if (!!students) {
            if (students > 1) {
                passengersPretty.push(students + 'x Students');
            } else {
                passengersPretty.push(students + 'x Student');
            }
        }
        if (!!children) {
            if (children > 1) {
                passengersPretty.push(children + 'x Children');
            } else {
                passengersPretty.push(children + 'x Child');
            }
        }
        if (!!seatedInfant) {
            if (seatedInfant > 1) {
                passengersPretty.push(seatedInfant + 'x Seated Infants');
            } else {
                passengersPretty.push(seatedInfant + 'x Seated Infant');
            }
        }
        if (!!nursedInfant) {
            if (nursedInfant > 1) {
                passengersPretty.push(nursedInfant + 'x Nursed Infants');
            } else {
                passengersPretty.push(nursedInfant + 'x Nursed Infant');
            }
        }
        return passengersPretty.join(', ');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/pretty-passenger.pipe.ts